import {
  OrdersPerformance,
  Performance
} from '@/ducks/performance/performance.types'

export type OrdersPerformanceDisplay = OrdersPerformance & {
  payoutAdjustedOrders?: Performance
}

const toPercentage = (count: number, total: number) =>
  ((count / Math.max(1, total)) * 100).toFixed(2)

export const withDerivedOrderBuckets = (
  performance: OrdersPerformance
): OrdersPerformanceDisplay => {
  if (performance.financially_delivered === undefined) {
    return performance
  }

  const payoutAdjustedCount = Math.max(
    0,
    performance.financially_delivered.count - performance.delivered.count
  )

  return {
    ...performance,
    returned: { count: 0, percentage: '0.00' },
    payoutAdjustedOrders: {
      count: payoutAdjustedCount,
      percentage: toPercentage(payoutAdjustedCount, performance.accepted.count)
    }
  }
}

export const getReturnedChartBucket = (performance: OrdersPerformanceDisplay) =>
  performance.payoutAdjustedOrders ?? performance.returned

export const usesPayoutAdjustedBucket = (
  performance: OrdersPerformanceDisplay
): boolean => performance.payoutAdjustedOrders !== undefined
